/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
export var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
    ContentType["Text"] = "text/plain";
})(ContentType || (ContentType = {}));
export class HttpClient {
    constructor(apiConfig = {}) {
        this.baseUrl = "https://6pctmc7iq3.execute-api.eu-west-1.amazonaws.com/{basePath}";
        this.securityData = null;
        this.abortControllers = new Map();
        this.customFetch = (...fetchParams) => fetch(...fetchParams);
        this.baseApiParams = {
            credentials: "same-origin",
            headers: {},
            redirect: "follow",
            referrerPolicy: "no-referrer",
        };
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.contentFormatters = {
            [ContentType.Json]: (input) => input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
            [ContentType.Text]: (input) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
            [ContentType.FormData]: (input) => Object.keys(input || {}).reduce((formData, key) => {
                const property = input[key];
                formData.append(key, property instanceof Blob
                    ? property
                    : typeof property === "object" && property !== null
                        ? JSON.stringify(property)
                        : `${property}`);
                return formData;
            }, new FormData()),
            [ContentType.UrlEncoded]: (input) => this.toQueryString(input),
        };
        this.createAbortSignal = (cancelToken) => {
            if (this.abortControllers.has(cancelToken)) {
                const abortController = this.abortControllers.get(cancelToken);
                if (abortController) {
                    return abortController.signal;
                }
                return void 0;
            }
            const abortController = new AbortController();
            this.abortControllers.set(cancelToken, abortController);
            return abortController.signal;
        };
        this.abortRequest = (cancelToken) => {
            const abortController = this.abortControllers.get(cancelToken);
            if (abortController) {
                abortController.abort();
                this.abortControllers.delete(cancelToken);
            }
        };
        this.request = (_a) => __awaiter(this, void 0, void 0, function* () {
            var { body, secure, path, type, query, format, baseUrl, cancelToken } = _a, params = __rest(_a, ["body", "secure", "path", "type", "query", "format", "baseUrl", "cancelToken"]);
            const secureParams = ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const queryString = query && this.toQueryString(query);
            const payloadFormatter = this.contentFormatters[type || ContentType.Json];
            const responseFormat = format || requestParams.format;
            return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (requestParams.headers || {})), (type && type !== ContentType.FormData ? { "Content-Type": type } : {})), signal: cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal, body: typeof body === "undefined" || body === null ? null : payloadFormatter(body) })).then((response) => __awaiter(this, void 0, void 0, function* () {
                const r = response;
                r.data = null;
                r.error = null;
                const data = !responseFormat
                    ? r
                    : yield response[responseFormat]()
                        .then((data) => {
                        if (r.ok) {
                            r.data = data;
                        }
                        else {
                            r.error = data;
                        }
                        return r;
                    })
                        .catch((e) => {
                        r.error = e;
                        return r;
                    });
                if (cancelToken) {
                    this.abortControllers.delete(cancelToken);
                }
                if (!response.ok)
                    throw data;
                return data;
            }));
        });
        Object.assign(this, apiConfig);
    }
    encodeQueryParam(key, value) {
        const encodedKey = encodeURIComponent(key);
        return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
    }
    addQueryParam(query, key) {
        return this.encodeQueryParam(key, query[key]);
    }
    addArrayQueryParam(query, key) {
        const value = query[key];
        return value.map((v) => this.encodeQueryParam(key, v)).join("&");
    }
    toQueryString(rawQuery) {
        const query = rawQuery || {};
        const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
        return keys
            .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
            .join("&");
    }
    addQueryParams(rawQuery) {
        const queryString = this.toQueryString(rawQuery);
        return queryString ? `?${queryString}` : "";
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.baseApiParams), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.baseApiParams.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
}
/**
 * @title motor-smartphotos-private-api
 * @version 0.0.12
 * @baseUrl https://6pctmc7iq3.execute-api.eu-west-1.amazonaws.com/{basePath}
 */
export class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.healthCheck = {
            /**
             * No description
             *
             * @tags public, health-check
             * @name HealthCheckGet
             * @request GET:/health-check
             */
            healthCheckGet: (params = {}) => this.request(Object.assign({ path: `/health-check`, method: "GET", format: "json" }, params)),
        };
        this.smartphotoId = {
            /**
             * @description Create log of a smartphoto
             *
             * @tags logs
             * @name LogsPost
             * @summary Create log of a smartphoto
             * @request POST:/{smartphoto_id}/logs
             */
            logsPost: (smartphotoId, data, params = {}) => this.request(Object.assign({ path: `/${smartphotoId}/logs`, method: "POST", body: data, type: ContentType.Json }, params)),
            /**
             * @description Request a GT estimation
             *
             * @tags gt-estimation
             * @name GtEstimationPut
             * @summary Request a GT estimation
             * @request PUT:/{smartphoto_id}/gt-estimation
             * @secure
             */
            gtEstimationPut: (smartphotoId, params = {}) => this.request(Object.assign({ path: `/${smartphotoId}/gt-estimation`, method: "PUT", secure: true }, params)),
            /**
             * No description
             *
             * @tags gt-estimation
             * @name GtEstimationOptions
             * @summary CORS support
             * @request OPTIONS:/{smartphoto_id}/gt-estimation
             */
            gtEstimationOptions: (smartphotoId, params = {}) => this.request(Object.assign({ path: `/${smartphotoId}/gt-estimation`, method: "OPTIONS" }, params)),
            /**
             * @description Send a report
             *
             * @tags report
             * @name ReportPost
             * @summary Send a report
             * @request POST:/{smartphoto_id}/send-report
             * @secure
             */
            reportPost: (smartphotoId, data, params = {}) => this.request(Object.assign({ path: `/${smartphotoId}/send-report`, method: "POST", body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags report
             * @name ReportsOptions
             * @summary CORS support
             * @request OPTIONS:/{smartphoto_id}/send-report
             */
            reportsOptions: (smartphotoId, params = {}) => this.request(Object.assign({ path: `/${smartphotoId}/send-report`, method: "OPTIONS" }, params)),
            /**
             * @description Get vehicle life cycle data
             *
             * @tags vlc
             * @name VlcGet
             * @summary Get vehicle life cycle data
             * @request GET:/{smartphoto_id}/vehicle-life-cycle
             * @secure
             */
            vlcGet: (smartphotoId, params = {}) => this.request(Object.assign({ path: `/${smartphotoId}/vehicle-life-cycle`, method: "GET", secure: true, format: "json" }, params)),
            /**
             * No description
             *
             * @tags vlc
             * @name VlcOptions
             * @summary CORS support
             * @request OPTIONS:/{smartphoto_id}/vehicle-life-cycle
             */
            vlcOptions: (smartphotoId, params = {}) => this.request(Object.assign({ path: `/${smartphotoId}/vehicle-life-cycle`, method: "OPTIONS" }, params)),
            /**
             * @description Get smartphoto required to display vehicle life cycle damage comparison
             *
             * @tags vlc, smartphoto
             * @name SmartphotoVlcGet
             * @summary Get smartphoto required to display vehicle life cycle damage comparison
             * @request GET:/{smartphoto_id}/smartphoto-vehicle-life-cycle
             * @secure
             */
            smartphotoVlcGet: (smartphotoId, params = {}) => this.request(Object.assign({ path: `/${smartphotoId}/smartphoto-vehicle-life-cycle`, method: "GET", secure: true, format: "json" }, params)),
            /**
             * No description
             *
             * @tags vlc, smartphoto
             * @name SmartphotoVlcOptions
             * @summary CORS support
             * @request OPTIONS:/{smartphoto_id}/smartphoto-vehicle-life-cycle
             */
            smartphotoVlcOptions: (smartphotoId, params = {}) => this.request(Object.assign({ path: `/${smartphotoId}/smartphoto-vehicle-life-cycle`, method: "OPTIONS" }, params)),
            /**
             * @description Generate signed URLs for files stored in S3.
             *
             * @tags sign-files
             * @name SignFilesPost
             * @summary Sign files in S3
             * @request POST:/{smartphoto_id}/sign-files
             * @secure
             */
            signFilesPost: (smartphotoId, data, params = {}) => this.request(Object.assign({ path: `/${smartphotoId}/sign-files`, method: "POST", body: data, secure: true, type: ContentType.Json, format: "json" }, params)),
            /**
             * No description
             *
             * @tags sign-files
             * @name SignFilesOptions
             * @summary CORS support
             * @request OPTIONS:/{smartphoto_id}/sign-files
             */
            signFilesOptions: (smartphotoId, params = {}) => this.request(Object.assign({ path: `/${smartphotoId}/sign-files`, method: "OPTIONS" }, params)),
            /**
             * @description Cancel a smartphoto
             *
             * @tags smartphoto
             * @name CancelSmartphoto
             * @summary Cancel a smartphoto
             * @request POST:/{smartphoto_id}/cancel
             */
            cancelSmartphoto: (smartphotoId, params = {}) => this.request(Object.assign({ path: `/${smartphotoId}/cancel`, method: "POST" }, params)),
            /**
             * @description Reviewed a smartphoto
             *
             * @tags smartphoto
             * @name ReviewedSmartphoto
             * @summary Reviewed a smartphoto
             * @request POST:/{smartphoto_id}/reviewed
             */
            reviewedSmartphoto: (smartphotoId, params = {}) => this.request(Object.assign({ path: `/${smartphotoId}/reviewed`, method: "POST" }, params)),
            /**
             * @description Submit audio of smartphoto description
             *
             * @tags smartphoto
             * @name TranscribeDescription
             * @summary Submit audio of smartphoto description
             * @request POST:/{smartphoto_id}/transcribe-description
             * @secure
             */
            transcribeDescription: (smartphotoId, data, params = {}) => this.request(Object.assign({ path: `/${smartphotoId}/transcribe-description`, method: "POST", body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags smartphoto
             * @name TranscribeDescriptionOptions
             * @summary CORS support
             * @request OPTIONS:/{smartphoto_id}/transcribe-description
             */
            transcribeDescriptionOptions: (smartphotoId, params = {}) => this.request(Object.assign({ path: `/${smartphotoId}/transcribe-description`, method: "OPTIONS" }, params)),
            /**
             * @description Update assigned basket of a smartphoto
             *
             * @tags smartphoto
             * @name UpdateBasketing
             * @summary Update assigned basket of a smartphoto
             * @request PUT:/{smartphoto_id}/basketing
             */
            updateBasketing: (smartphotoId, data, params = {}) => this.request(Object.assign({ path: `/${smartphotoId}/basketing`, method: "PUT", body: data, type: ContentType.Json }, params)),
        };
        this.createSmartphotoByFile = {
            /**
             * @description Create smartphoto by file
             *
             * @tags smartphoto
             * @name CreateSmartphotoByFile
             * @summary Create smartphoto by file
             * @request POST:/create-smartphoto-by-file
             */
            createSmartphotoByFile: (data, params = {}) => this.request(Object.assign({ path: `/create-smartphoto-by-file`, method: "POST", body: data, type: ContentType.Json }, params)),
        };
        this.metricsDashboard = {
            /**
             * No description
             *
             * @tags metrics-dashboard
             * @name MetricsDashboardOptions
             * @summary CORS support
             * @request OPTIONS:/metrics-dashboard
             */
            metricsDashboardOptions: (params = {}) => this.request(Object.assign({ path: `/metrics-dashboard`, method: "OPTIONS" }, params)),
            /**
             * @description Get metrics dashboard link
             *
             * @tags metrics-dashboard
             * @name MetricsDashboardGet
             * @summary Get metrics dashboard link
             * @request GET:/metrics-dashboard
             * @secure
             */
            metricsDashboardGet: (params = {}) => this.request(Object.assign({ path: `/metrics-dashboard`, method: "GET", secure: true, format: "json" }, params)),
        };
    }
}
